<section class="content price">
<!--  <app-pricing-quantity></app-pricing-quantity>-->
  <app-pricing-time></app-pricing-time>
</section>
